export const COMPLAINTS_HEADER_OPTIONS = [
  {
    title: "Site/ID",
    sortArrow: true,
    sortBy: "alphabetically",
    address: ["station", "name"],
  },
  {
    title: "Field Technician",
    sortArrow: true,
    sortBy: "alphabetically",
    address: ["fieldTechnician", "fullName"],
  },
  {
    title: "Supervisor",
    sortArrow: true,
    sortBy: "alphabetically",
    address: ["supervisor", "fullName"],
  },
  {
    title: "Created At",
    sortArrow: true,
    sortBy: "date",
    address: ["createdAt"],
  },
  {
    title: "Updated At",
    sortArrow: true,
    sortBy: "date",
    address: ["updatedAt"],
  },
  { title: "Description" },
  {
    title: "Category",
    sortArrow: true,
    sortBy: "alphabetically",
    address: ["category", "name"],
  },
  { title: "Visit" },
  {
    title: "Last Visit Date",
    sortArrow: true,
    sortBy: "date",
    address: ["last_visit_date"],
  },
  { title: "Details" },
  { title: "Action" },
];

export const COMPLAINTS_PENDING_HEADERS = [
  {
    title: "Site/ID",
    sortArrow: true,
    sortBy: "alphabetically",
    address: ["station", "name"],
  },
  {
    title: "Field Technician",
    sortArrow: true,
    sortBy: "alphabetically",
    address: ["fieldTechnician", "fullName"],
  },
  {
    title: "Supervisor",
    sortArrow: true,
    sortBy: "alphabetically",
    address: ["supervisor", "fullName"],
  },
  {
    title: "Created At",
    sortArrow: true,
    sortBy: "date",
    address: ["createdAt"],
  },
  { title: "Description" },
  {
    title: "Category",
    sortArrow: true,
    sortBy: "alphabetically",
    address: ["category", "name"],
  },
  { title: "Visit" },
  {
    title: "Last Visit Date",
    sortArrow: true,
    sortBy: "date",
    address: ["last_visit_date"],
  },
  { title: "Action" },
];

export const CYLINDER_CHANGE_COLUMNS = [
  {
    title: "Site",
    sortArrow: true,
    sortBy: "alphabetically",
    address: ["stationID"],
  },
  {
    title: "Field Technician",
    sortArrow: true,
    sortBy: "alphabetically",
    address: ["fieldTechnicianName"],
  },
  {
    title: "Supervisor",
    sortArrow: true,
    sortBy: "alphabetically",
    address: ["supervisorName"],
  },
  {
    title: "Complaint Date",
    sortArrow: true,
    sortBy: "date",
    address: ["complaintDate"],
  },
  {
    title: "Date Of Complaint Attended",
    sortArrow: true,
    sortBy: "date",
    address: ["dateOfComplainAttended"],
  },
  {
    title: "Working Cylinder",
  },
  {
    title: "Standby Cylinder",
  },
  {
    title: "Last Working Cylinder",
  },
  {
    title: "Last Standby Cylinder",
  },
  {
    title: "Dose Set",
  },
  {
    title: "Daily Supply Hour",
  },
];

export const VEHICLE_READING_COLUMNS = [
  {
    title: "Reading Date",
    sortArrow: true,
    sortBy: "date",
    address: ["logDate"],
  },
  {
    title: "Vehicle Number",
  },
  {
    title: "Created By",
    sortArrow: true,
    sortBy: "alphabetically",
    address: ["createdBy", "fullName"],
  },
  {
    title: "Morning Reading Time",
  },
  {
    title: "Morning Reading",
    sortArrow: true,
    sortBy: "number",
    address: ["morningReading"],
  },
  {
    title: "Evening Reading Time",
  },
  {
    title: "Evening Reading",
    sortArrow: true,
    sortBy: "number",
    address: ["eveningReading"],
  },
  {
    title: "Distance",
    sortArrow: true,
    sortBy: "number",
    address: ["distanceKm"],
  },
  { title: "Status", sortArrow: true, sortBy: "number", address: ["status"] },
  { title: "Action" },
];

export const PENDING_VEHICLE_READING_COLUMNS = VEHICLE_READING_COLUMNS.filter(
  (column) => column.title !== "Status",
);
